export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Підтвердження"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скасувати"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Так"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви впевнені, що хочете продовжити?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Видалити крипто-актив"])}
}